import React from 'react';

const x = (props) => {
    return (
        <div className="d-flex flex-column">
            <img src={process.env.REACT_APP_IMAGES_URL + '/A1_end_icon_32.png'} alt=""
                 className="d-block mx-auto" style={{height: "27px"}}/>
            <small className="text-red d-block"> {props.packageName} </small>
        </div>
    )
};

export default x;